import apiReq from 'core/api';
import { FETCH_USER_START, FETCH_USER_SUCCESS, FETCH_USER_FAILURE, CLEAR_USER } from './types';
import { setIsAdmin, setCurrRole, setProjects, setCurrProject } from './reducers';
import { userStorage } from '../utils/userStorage';

const PROJECT_STORAGE_KEY = 'current_project_id';

// User actions
export const fetchUserStart = () => ({
  type: FETCH_USER_START,
});

export const fetchUserSuccess = (user) => ({
  type: FETCH_USER_SUCCESS,
  payload: user,
});

export const fetchUserFailure = (error) => ({
  type: FETCH_USER_FAILURE,
  payload: error,
});

export const clearUser = () => ({
  type: CLEAR_USER,
});

// Async action to fetch user info (идемпотентно: не запускаем повторно, если уже идёт загрузка или пользователь уже есть)
export const fetchUserInfo = () => async (dispatch, getState) => {
  const { reducer } = getState() || {};
  if (reducer?.user?.loading || reducer?.user?.data) {
    return;
  }
  try {
    dispatch(fetchUserStart());
    const [user, projects] = await Promise.all([apiReq('auth/info'), apiReq('projects/personal')]);
    dispatch(fetchUserSuccess(user));
    dispatch(setIsAdmin(user.is_admin));
    dispatch(setProjects(projects || []));

    // Восстанавливаем роль из localStorage (как и проект)
    const savedRoleId = localStorage.getItem('selected_role_id');
    const roleToSet =
      savedRoleId && user.roles?.length
        ? user.roles.find((r) => String(r.id) === savedRoleId)
        : null;
    dispatch(setCurrRole(roleToSet || user.roles[0]));

    // Восстанавливаем проект из localStorage (как роль)
    const savedProjectId = localStorage.getItem(PROJECT_STORAGE_KEY);
    const projectList = projects || [];
    const projectToSet =
      savedProjectId && projectList.length
        ? projectList.find((p) => String(p.id) === savedProjectId) || projectList[0]
        : projectList[0];
    if (projectToSet) {
      const projectId = String(projectToSet.id);
      dispatch(setCurrProject({ id: projectId }));
      try {
        localStorage.setItem(PROJECT_STORAGE_KEY, projectId);
      } catch {
        // ignore localStorage errors
      }
    }

    localStorage.setItem('yandex_auth', user.has_yandex_access);
    localStorage.setItem('jira_auth', user.has_jira_access);
    if (user.id) {
      userStorage.set(String(user.id));
    }
  } catch (error) {
    dispatch(fetchUserFailure(error.message || 'Ошибка получения данных пользователя'));
  }
};
